/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Filter/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Filter({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/AccountSelect/Content/Filter"
  
}) {
let paymentsPostPaymentPayorFilterValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payor_filter',
})
let constantData = 'EXISTING'
let aggregateData = fromAggregate.equals(paymentsPostPaymentPayorFilterValueData, constantData)
let onClick = fromHelpers.useOnClickExisting({
  children,
  viewPath
  
})
let paymentsPostPaymentPayorFilterValueData1 = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payor_filter',
})
let constantData1 = 'NEW'
let aggregateData1 = fromAggregate.equals(paymentsPostPaymentPayorFilterValueData1, constantData1)
let onClick1 = fromHelpers.useOnClickNew({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Filter.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Filter.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="payments_post_payment.payor_filter"
 data="'EXISTING'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 text="Existing payors"
/>
</div>
<div
  data-testid="Filter.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick1}
 data="payments_post_payment.payor_filter"
 data="'NEW'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
 text="New payors"
/>
</div>
</div>
{children}
</React.Fragment>)
}